/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccountBalanceApiModel } from '../../models/account-balance-api-model';

export interface RetrieveBalance$Params {
}

export function retrieveBalance(http: HttpClient, rootUrl: string, params?: RetrieveBalance$Params, context?: HttpContext): Observable<StrictHttpResponse<AccountBalanceApiModel>> {
  const rb = new RequestBuilder(rootUrl, retrieveBalance.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccountBalanceApiModel>;
    })
  );
}

retrieveBalance.PATH = '/funds';
